import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {
  useGetAgencyQuery,
  useUpdateAgencyCorrectiveSettingsMutation,
  useUpdateCorporateCorrectiveMutation,
} from '../../../store/builder/inspections.api';
import {setLoader} from '../../../store/builder/reducer';
import {toast} from 'react-toastify';
import Input from '../../Input';
import CustomSelect from '../../CustomSelect';
import {useTranslation} from '../../../hooks/useTranslation';

const CorporateCorrectiveActions = () => {
  const {t} = useTranslation();
  const dispatch = useDispatch();
  const userInfo = useSelector(state => state?.rootReducer?.loginSlice?.user);

  const [
    updateCorporateCorrectiveSettings,
    {
      data: updateCorporateData,
      isError: updateCorporateIsError,
      isLoading: updateCorporateIsLoading,
      isSuccess: updateCorporateIsSuccess,
      error: updateCorporateError,
    },
  ] = useUpdateCorporateCorrectiveMutation();

  const [changeData, setChangeData] = useState({});
  
  const solidRating = [
    {
      value: 1,
      label: t('corporateCorrectiveActions.ratings.solid.clean'),
    },
    {
      value: 2,
      label: t('corporateCorrectiveActions.ratings.solid.slight'),
    },
    {
      value: 3,
      label: t('corporateCorrectiveActions.ratings.solid.particulate'),
    },
    {
      value: 4,
      label: t('corporateCorrectiveActions.ratings.solid.dirty'),
    },
  ];
  
  const waterRating = [
    {
      value: 'A',
      label: t('corporateCorrectiveActions.ratings.water.bright'),
    },
    {
      value: 'B',
      label: t('corporateCorrectiveActions.ratings.water.hazy'),
    },
    {
      value: 'C',
      label: t('corporateCorrectiveActions.ratings.water.cloudy'),
    },
    {
      value: 'D',
      label: t('corporateCorrectiveActions.ratings.water.wet'),
    },
    {
      value: 'E',
      label: t('corporateCorrectiveActions.ratings.water.surfactants'),
    },
  ];

  useEffect(() => {
    if (userInfo?.corporate) {
      setChangeData({
        nozzle_fueling_pressure: userInfo?.corporate?.nozzle_fueling_pressure,
        sump_solid_rating: userInfo?.corporate?.sump_solid_rating,
        sump_water_rating: userInfo?.corporate?.sump_water_rating,
        sump_trend_alert: userInfo?.corporate?.sump_trend_alert,
        differential_pressure: userInfo?.corporate?.differential_pressure,
        nozzle_fueling_pressure_decommission:
          userInfo?.agency?.nozzle_fueling_pressure_decommission,
        // differential_pressure_decommission: userInfo?.agency?.differential_pressure_decommission
      });
    }
  }, [userInfo]);

  useEffect(() => {
    if (updateCorporateIsLoading) {
      dispatch(setLoader(true));
    } else {
      dispatch(setLoader(false));
    }
  }, [updateCorporateIsLoading]);

  const handleInput = e => {
    setChangeData(old => ({...old, [e.target.name]: e.target.value}));
  };

  const updateSettings = () => {
    const formData = new FormData();
    formData.append('sump_solid_rating', changeData?.sump_solid_rating);
    formData.append('sump_water_rating', changeData?.sump_water_rating);
    formData.append('sump_trend_alert', changeData?.sump_trend_alert);
    formData.append(
      'nozzle_fueling_pressure',
      changeData?.nozzle_fueling_pressure,
    );
    formData.append('differential_pressure', changeData?.differential_pressure);
    formData.append(
      'nozzle_fueling_pressure_decommission',
      changeData?.nozzle_fueling_pressure_decommission,
    );
    // formData.append('differential_pressure_decommission', changeData?.differential_pressure_decommission);

    if (changeData?.sump_trend_alert) {
      updateCorporateCorrectiveSettings(formData)
        .then(res => {
          if (res?.error?.data?.message) {
            toast.error(res?.error?.data?.message);
          } else {
            toast.success(res?.data?.message);
          }
        })
        .catch(error => {
          toast.error(error.message);
        });
    }
    if (!changeData?.sump_trend_alert) {
      toast.error(t('corporateCorrectiveActions.messages.sumpTrendAlertRequired'));
    }
  };

  return (
    <div style={{ pointerEvents: userInfo?.is_sso_auth ? 'none' : 'auto'}}>
      <div className='profile__info profile'>
        <div className='profile__info column'>
          <p className='profile__title'>{t('corporateCorrectiveActions.title')}</p>
          <p className='profile__subtitle'>
            {t('corporateCorrectiveActions.subtitle')}
          </p>
          <div className='profile-corrective-actions'>
            <Input
              tooltip={true}
              tooltipText={t('corporateCorrectiveActions.nozzleFuelingPressureTooltip')}
              label={t('corporateCorrectiveActions.nozzleFuelingPressure')}
              maxwidth={395}
              placeholder={t('corporateCorrectiveActions.nozzleFuelingPressure')}
              name={'nozzle_fueling_pressure'}
              defaultValue={userInfo?.corporate?.nozzle_fueling_pressure}
              onChange={handleInput}
            />
            <Input
              tooltip={true}
              tooltipText={t('corporateCorrectiveActions.differentialPressureTooltip')}
              label={t('corporateCorrectiveActions.differentialPressure')}
              maxwidth={395}
              placeholder={t('corporateCorrectiveActions.differentialPressure')}
              name={'differential_pressure'}
              defaultValue={userInfo?.corporate?.differential_pressure}
              onChange={handleInput}
            />
            <CustomSelect
              tooltip={true}
              tooltipText={t('corporateCorrectiveActions.sumpSolidRatingTooltip')}
              label={t('corporateCorrectiveActions.sumpSolidRating')}
              tooltipWidth={250}
              placeholder={t('corporateCorrectiveActions.sumpSolidRating')}
              name={'sump_solid_rating'}
              defaultValue={
                userInfo?.corporate?.sump_solid_rating
                  ? solidRating.filter(
                      el => el.value == userInfo?.corporate?.sump_solid_rating,
                    )[0]
                  : ''
              }
              onChange={handleInput}
              options={solidRating}
              maxwidth={'100%'}
            />
            <CustomSelect
              tooltip={true}
              tooltipText={t('corporateCorrectiveActions.sumpWaterRatingTooltip')}
              label={t('corporateCorrectiveActions.sumpWaterRating')}
              tooltipWidth={250}
              maxwidth={'100%'}
              placeholder={t('corporateCorrectiveActions.sumpWaterRating')}
              name={'sump_water_rating'}
              defaultValue={
                userInfo?.corporate?.sump_water_rating
                  ? waterRating?.filter(
                      el => el.value === userInfo?.corporate?.sump_water_rating,
                    )[0]
                  : ''
              }
              onChange={handleInput}
              options={waterRating}
            />
            <div style={{marginTop: '15px'}}>
              <Input
                tooltip={true}
                tooltipText={t('corporateCorrectiveActions.nozzleFuelingPressureDecommission')}
                label={t('corporateCorrectiveActions.nozzleFuelingPressureDecommission')}
                maxwidth={395}
                placeholder={t('corporateCorrectiveActions.nozzleFuelingPressureDecommission')}
                name={'nozzle_fueling_pressure_decommission'}
                defaultValue={
                  userInfo?.corporate?.nozzle_fueling_pressure_decommission
                }
                onChange={handleInput}
              />
            </div>
            {/*<div style={{marginTop: '30px'}}>*/}
            {/*<Input*/}
            {/*  tooltip={true}*/}
            {/*  tooltipText={"Differential Pressure Decommission"}*/}
            {/*  label={"Differential Pressure Decommission"}*/}
            {/*  maxwidth={395}*/}
            {/*  placeholder={"Differential Pressure Decommission"}*/}
            {/*  name={"differential_pressure_decommission"}*/}
            {/*  defaultValue={userInfo?.agency?.differential_pressure_decommission}*/}
            {/*  onChange={handleInput}*/}
            {/*/>*/}
            {/*</div>*/}
            <div style={{marginTop: '15px'}}>
              <Input
                tooltip={true}
                tooltipText={t('corporateCorrectiveActions.sumpTrendAlertTooltip')}
                label={t('corporateCorrectiveActions.sumpTrendAlert')}
                maxwidth={395}
                placeholder={t('corporateCorrectiveActions.sumpTrendAlert')}
                name={'sump_trend_alert'}
                defaultValue={userInfo?.corporate?.sump_trend_alert}
                onChange={handleInput}
              />
            </div>
          </div>
        </div>
        {!userInfo?.is_sso_auth && <button
            style={{marginTop: '15px', width: '130px'}}
            className='profile__methods-btn'
            onClick={updateSettings}
        >
          {t('corporateCorrectiveActions.save')}
        </button>}
      </div>
    </div>
  );
};

export default CorporateCorrectiveActions;
